import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Section from '../ui/Section';
import { skills } from '../../data/skills';
import SkillCategory from './SkillCategory';
import SkillDetailModal from './SkillDetailModal';
import { Skill } from '../../types';

const CATEGORY_CONFIG = {
  languages: { name: 'Linguaggi & Framework', icon: '💻' },
  databases: { name: 'Database', icon: '🗄️' },
  systems: { name: 'Sistemi', icon: '⚙️' },
  network: { name: 'Network & Infrastructure', icon: '🌐' },
  industrial: { name: 'Industriale', icon: '🏭' },
  web: { name: 'Web & UI/UX', icon: '🎨' },
  tools: { name: 'Dev Tools', icon: '🛠️' },
};

const Skills: React.FC = () => {
  const [selectedSkill, setSelectedSkill] = useState<Skill | null>(null);

  // Raggruppa skills per categoria
  const groupedSkills = Object.entries(CATEGORY_CONFIG).reduce(
    (acc, [categoryId, _]) => {
      acc[categoryId] = skills.filter(skill => skill.category === categoryId);
      return acc;
    },
    {} as Record<string, Skill[]>
  );

  return (
    <Section
      id="skills"
      title="Competenze"
      subtitle="Le tecnologie e gli strumenti che utilizzo quotidianamente."
    >
      <motion.div
        layout
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
      >
        {Object.entries(CATEGORY_CONFIG).map(([categoryId, config]) => (
          <SkillCategory
            key={categoryId}
            categoryId={categoryId}
            categoryName={config.name}
            icon={config.icon}
            skills={groupedSkills[categoryId]}
            onSkillClick={setSelectedSkill}
          />
        ))}
      </motion.div>

      {selectedSkill && (
        <SkillDetailModal
          skill={selectedSkill}
          onClose={() => setSelectedSkill(null)}
        />
      )}
    </Section>
  );
};

export default Skills;